import { render, staticRenderFns } from "./Tabell.vue?vue&type=template&id=a3ca0002&"
import script from "./Tabell.vue?vue&type=script&lang=js&"
export * from "./Tabell.vue?vue&type=script&lang=js&"
import style0 from "./Tabell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports